/* util/core */

define(
	'util/core',[
		'jquery',
		'velocity',
		'pubsub'
	],
	function( $, Velocity ) {

		'use strict';

		var scrollComplete = function() {
			window.setTimeout(
				function () {
					$.publish('/header/hide');
				},
				250
			);
		};

		return {

			// Scroll to an element on screen
			// $elm = jQuery element - the element to scroll to
			scrollToElm: function( $elm ) {
				$elm.velocity('scroll',
					{
						duration: 1000,
						easing: 'ease-in-out',
						complete: scrollComplete
					}
				);
			},

			// Returns a class name with no '.'
			// selector = string - the jQuery selector to remove '.' from
			getClassName: function( selector ) {
				return selector.replace( '.', '' );
			},

			// Returns an object containing the current URL's query string
			getQueryStringObject: function (query) {
				var queryString = typeof query !== 'undefined' ? query : document.location.search.substr(1);
				var queryArray = queryString.split('&');
				var filters = [];
				var obj = {};

				for (var i = 0; i < queryArray.length; i++) {
					queryArray[i] = queryArray[i].split('=');

					if (queryArray[i].length > 1) {
						var key = decodeURIComponent(queryArray[i][0]);
						var val = decodeURIComponent(queryArray[i][1]);

						filters.push({
							filterName: key,
							filterOption: val
						});

						if (obj[key]) {
							if (Array.isArray(obj[key]) === false) {
								obj[key] = [obj[key]];
							}
							obj[key] = obj[key].concat([val]);
						} else {
							obj[key] = val;
						}
					}
				}

				var queryObj = {
					queryString: queryString,
					filters: filters,
					obj: obj
				};

				return queryObj;
			},

			// Creates a callback that, when bound to a keydown event,
			// will only trigger on that event when the "Enter" key is pressed.
			// Any other bound events (e.g. 'click' above) will always be triggered.

			// Example usage:
			// e.g. $(document).on('click keydown', selector, activate(callback));
			activate: function ( callback ) {
				return function(e) {
					if (e.type !== 'keydown' || e.which === 13) {
						// Enter key (keycode 13)
						callback.apply(this, arguments);
					}
				};
			}
		};
	}
);
